import api from './api'

function unwrapPaginated(raw) {
  if (!raw) return []
  const inner = raw?.data?.data ?? raw?.data
  if (Array.isArray(inner)) return inner
  if (Array.isArray(inner?.data)) return inner.data
  return []
}

export const mascotaHistorialService = {
  unwrapPaginated,

  async getRegistrosAltura(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/registros-altura`, { params })
    return { success: true, data: unwrapPaginated(response.data), raw: response.data }
  },

  async getRegistrosVacunas(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/registros-vacunas`, { params })
    return { success: true, data: unwrapPaginated(response.data), raw: response.data }
  },

  async getRegistrosDesparasitacion(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/registros-desparasitacion`, { params })
    return { success: true, data: unwrapPaginated(response.data), raw: response.data }
  },

  async getRecordatorios(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/recordatorios`, { params })
    return { success: true, data: unwrapPaginated(response.data), raw: response.data }
  },

  async getAdjuntos(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/adjuntos`, { params })
    return { success: true, data: unwrapPaginated(response.data), raw: response.data }
  },
}
